<template>
    <el-dropdown-item>
        <a :href="href" target="_blank">
            <component :is="icons[icon]"/>
            <span class="bold pr-1">{{ title }} </span>
            <span :class="`c-${getPrimaryColor}four medium`">{{ content }}</span>
        </a>
    </el-dropdown-item>
</template>

<script>
import Email from '@/components/icons/navbar/Email.vue';
import WhatsApp from '@/components/icons/navbar/WhatsApp.vue';

export default {
    props: {
        href: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
    },
    components: {
        WhatsApp,
        Email,
    },

    data() {
        return {
            icons: {
                ...this.components
            }
        };
    },
}
</script>
<style scoped lang="scss">
    a:hover {
        color: unset !important;
    }
</style>
